import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
// import ProgressIcon from "../../../images/ProgressIcon.svg";
import {
  get_progress_monitor,
  get_progress_monitor_close,
} from "../../../Store/Reducers/Categories/actions";

export default function GetProgressMonitor() {
  const dispatch = useDispatch();
  const {
    progress_monitor_bool,
    progress_monitor_reflected_indexes,
    monitor_id,
    monitor_current_progress,
    monitor_max_progress,
  } = useSelector((state) => state.Categories);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (monitor_max_progress === null || monitor_max_progress === 0) {
      dispatch(get_progress_monitor_close());
    }
    // if (progress_monitor_bool) {
    //   const callMonitor = setInterval(() => {
    //     if (monitor_max_progress !== monitor_current_progress) {
    //       dispatch(get_progress_monitor(monitor_id));
    //     }
    //     if (monitor_max_progress === monitor_current_progress) {
    //       dispatch(get_progress_monitor_close());
    //       clearInterval(callMonitor);
    //     }
    //   }, 500);
    //   if (!progress_monitor_bool) {
    //     clearInterval(callMonitor);
    //   }
    // } else {
    //   dispatch(get_progress_monitor_close());
    // }
    if (monitor_id) {
      dispatch(get_progress_monitor(monitor_id));
    }
  }, [progress_monitor_bool, monitor_max_progress]);

  useEffect(() => {
    if (progress_monitor_bool)
      setTimeout(() => {
        dispatch(get_progress_monitor_close());
      }, 10000);
  }, [progress_monitor_bool, monitor_max_progress]);

  return (
    <Wrapper>
      {progress_monitor_bool ? (
        <>
          <div className="progress_moniter_bar">
            {/* <img src={ProgressIcon} /> */}
            <h5>
              Processing updating indexes: {monitor_current_progress}/
              {monitor_max_progress}
            </h5>
          </div>
        </>
      ) : null}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .progress_moniter_bar {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: auto;
    padding: 10px;
    display: flex;
    justify-content: space-between;

    z-index: 9999999;
    background-color: white;
  }

  h5 {
    margin: 0px 10px;
    font-family: "Lato";
    font-weight: 500;
    font-size: 18px;
    color: #002733;
  }
`;
